import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

class NotificationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
     console.log("this.prps" , this.props);
    return (
      <>
        <Modal show={this.props.show} onHide={this.props.handleClose}>
          <Modal.Header closeButton>
            <h4>{this.props.fulldescription.title}</h4>
          </Modal.Header>
          <Modal.Body>
            <div style={{color : "#505455"}}>
              {"Service Type :"} {this.getserviceType(this.props.fulldescription.serviceType)}
              {/* <br/>
              {"Service Date :"}  {this.props.exactadata.service_date}
              <br/>
              {"Hours To Complete :"}  {this.props.exactadata.hourstoComplete} */}
            <br />
             {"Employee Name : "  } {this.props.fulldescription.senderName}
             <br/>
              {this.props.fulldescription.message}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }



  getserviceType = (ein) => {
  
    let data = [{ id : "1" ,  name  : "Building"} , {id  : "2" , name  : "Equipment"  } , {id  : "3" , name  : "Vehicle" } ];
   
   var name = " " ;

    if (ein === null){
     
      name = "Task" 

    }else {
      data.forEach(e => {
        if (e.id === ein) {
          name = e.name;
        }
      });
    }

   

    return name ;
    

  }




}
export default NotificationDetails;
